import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getPippUserData = async (pippId) => {
  const response = await axios.post(
    routes.pippUserData,
    { pippId },
    AXIOS_DEFAULT_CONFIG
  );

  const token = response.data?.token;
  if (token) {
    localStorage.setItem("authToken", token);
  }
  return response;
};

export default getPippUserData;
